import React from 'react'
import HeadTop from './HeadTop'
import LowerBar from './LowerBar/LowerBar'
import Ticker from './Ticker'
import Topbar from './Topbar'

const Header = () => {
  return (
    <>
    <Ticker/>
    <HeadTop/>
    <Topbar/>
    <LowerBar/>
    </>
  )
}

export default Header